<template>
  <div>
    <b-alert
      :show="this.form.bup_others_explosive.length && !form.periode"
      variant="danger"
    >
      Fields contractor and period must be filled first
    </b-alert>
    <b-button
      v-if="!isView && (this.form.bup_others_explosive.length === 0 || this.form.bup_others_explosive.length < otherRate.length)"
      class="btn-custom px-5 mb-3"
      variant="info"
      size="sm"
      @click="addRowExplosive"
    >
      Add
    </b-button>
    <b-table
      thead-class="bg-color text-center"
      tbody-class="table-body"
      tfoot-class="table-body text-center"
      empty-text="No data"
      :items="form.bup_others_explosive"
      :fields="explosiveFields"
      show-empty
      responsive
      bordered
      foot-clone
    >
      <template v-slot:cell(description)="{ item, index }">
        <validation-provider
          name="Description Explosive"
          rules="required"
          v-slot="{ errors }"
          slim
          class="flex-fill mr-4"
        >
          <b-form-select
            autocapitalize="off"
            v-model="item.contractor_other_rate_id"
            :options="otherRate"
            value-field="id"
            text-field="description"
            @input="(item) => onDescriptionChange(item, index)"
            :class="{ 'is-invalid': errors.length }"
            :disabled="isView ? isView : !form.periode"
          >
            <template #first>
              <b-form-select-option :value="''" disabled>Select Description</b-form-select-option>
            </template>
          </b-form-select>
        </validation-provider>
      </template>
      <template v-slot:cell(qty)="{ item }">
        <validation-provider
          name="Quantity Explosive"
          rules="required|min_value:1"
          v-slot="{ errors }"
          slim
          class="flex-fill mr-4"
        >
          <b-form-input
            v-model="item.qty"
            autocapitalize="off"
            placeholder="Enter Qty"
            type="number"
            size="sm"
            :class="{ 'is-invalid': errors.length }"
            :invalid-feedback="errors[0]"
            :disabled="isView"
          />
        </validation-provider>
      </template>
      <template v-slot:cell(code)="{ item }">
        {{ item.code ? item.code : '-' }}
      </template>
      <template v-slot:cell(unit)="{ item }">
        {{ item.unit ? item.unit : '-' }}
      </template>
      <template v-slot:cell(price_unit_usd)="{ item }">
        {{ formatMoney(item.price_unit_usd, { symbol: '', precision: '2', thousand: ',' }) }}
      </template>
      <template v-slot:cell(price_unit_idr)="{ item }">
        {{ formatMoney(item.price_unit_idr, { symbol: '', precision: '2', thousand: ',' }) }}
      </template>
      <template v-slot:cell(amount)="{ item }">
        <div>
          {{ formatMoney(item.qty ? item.qty * item.price_unit_idr : 0, { symbol: '', precision: '2', thousand: ',' }) }}
        </div>
      </template>
      <template v-slot:cell(actions)="{ index }">
        <b-button
          v-if="!isView"
          variant="link"
          class="text-decoration-none text-danger p-0"
          @click="removeExplosive(index)"
        >
          <fa-icon icon="times-circle" />
        </b-button>
      </template>
      <template #foot(description)>
        Total
      </template>
      <template #foot()>
        {{ '' }}
      </template>
      <template #foot(amount)>
        {{ formatMoney(subTotal(form.bup_others_explosive), { symbol: '', precision: '2', thousand: ',' }) }}
      </template>
    </b-table>
    <br>

    <h6 class="font-weight-bold">Attachment Supporting Document</h6>
    <div v-if="!isView" class="mt-4">
      <div>
        <div class="dropbox">
          <input
            type="file"
            @change="onChangeFile($event.target.files)"
            class="input-file"
            multiple
            accept=".xls, .xlsx, .doc, .docx, .pdf"
          >
            <img
              class="mt-2"
              src="@/assets/icon-upload.png"
              width="100"
              height="100"
            >
            <div>
              <p id="text-dropbox">Drag or klik button to upload file</p>
            </div>
            <b-button
              class="btn-custom"
              variant="info"
              size="sm"
            >
              Browse File
            </b-button>
        </div>
      </div>
    </div>
    <div
      v-if="attachmentExplosive.length"
      :style="gridStyle"
      class="card-list mt-2 p-0"
      id="attachment"
    >
      <div
        v-for="(item, index) in attachmentExplosive"
        :key="index"
        class="supporting-file"
      >
      <div
          class="dropbox-files mx-1 mb-2"
        >
          <div
            v-if="item.file_name"
            class="background-file"
          >
            <div class="d-flex justify-content-end">
              <img
                v-if="!isView"
                class="mr-2 mt-2"
                src="@/assets/icon-trash.png"
                width="25"
                height="25"
                style="cursor: pointer"
                @click="removeFile(index, item.id)"
              >
            </div>
            <div class="pointer" @click="downloadFile(item)">
              <img
                v-if="checkType(item.file_name) === attachmentType[0] || checkType(item.file_name) === attachmentType[1]"
                class="mb-4"
                :class="{ 'mt-4': isView }"
                src="@/assets/icon-excel.png"
                width="70"
                height="70"
              >
              <img
                v-else-if="checkType(item.file_name) === attachmentType[4]"
                class="mb-4"
                :class="{ 'mt-4': isView }"
                src="@/assets/icon-pdf.png"
                width="70"
                height="70"
              >
              <img
                v-else-if="checkType(item.file_name) === attachmentType[2] || checkType(item.file_name) === attachmentType[3]"
                class="mb-4"
                :class="{ 'mt-4': isView }"
                src="@/assets/icon-word.png"
                width="70"
                height="70"
              >
            </div>
          </div>
          <div
            class="text mt-2"
          >
            <span class="text-ellipsis mx-2">{{ item ? item.file_name : 'NaN'}}</span>
            <span class="size-file">{{ item ? item.size : 'NaN mb'}}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isView && !attachmentExplosive.length" class="w-100 text-center">No Attachment</div>
  </div>
</template>

<script>
import api from '@/api'
import { formatMoney } from 'accounting-js'

export default {
  props: {
    isView: {
      types: Boolean,
      default: false
    },
    isEdit: {
      types: Boolean,
      default: false
    },
    form: {
      types: Object,
      default: () => {}
    },
    otherRate: {
      types: Array,
      default: () => {}
    },
    fuelPrice: {
      types: Object,
      default: () => {}
    },
    contractor: {
      types: Object,
      default: () => {}
    }
  },

  components: {},

  data: () => ({
    explosiveFields: [
      { key: 'description', label: 'Description', tdClass: 'text-center' },
      { key: 'code', label: 'Code', tdClass: 'text-center align-middle' },
      { key: 'unit', label: 'Unit', tdClass: 'text-center align-middle' },
      { key: 'qty', label: 'Qty', tdClass: 'text-center' },
      { key: 'price_unit_usd', label: 'Price/Unit (USD)', tdClass: 'text-center align-middle' },
      { key: 'price_unit_idr', label: 'Price/Unit (IDR)', tdClass: 'text-center align-middle' },
      { key: 'amount', label: 'Amount (IDR)', tdClass: 'text-center align-middle' },
      { key: 'actions', tdClass: 'text-center', thStyle: 'width: 75px' }
    ],
    numberOfColumns: 4,
    attachmentExplosive: [],
    attachmentType: ['xlsx', 'xls', 'doc', 'docx', 'pdf'],
    isUpload: false,
    upload: {
      progress: 0,
      variant: 'success'
    },
    bupOther: []
  }),

  computed: {
    gridStyle() {
      return {
        gridTemplateColumns: `repeat(${this.numberOfColumns}, minmax(25%, 1fr))`
      }
    }
  },

  mounted() {
    if (this.$route.params.id) {
      this.fetchAttachment()
    }
  },

  methods: {
    formatMoney,
    async fetchAttachment() {
      this.attachmentExplosive = await api.other.getAttachment(this.$route.params.id, 'Explosive')
    },
    onDescriptionChange(id, index) {
      const data = this.otherRate.find(v => v.id === id)
      const newOtherRate = this.otherRate.map(v => {
        if (this.form.bup_others_explosive.length) {
          if (v.id === id) {
            v.disabled = true
          }
        } else {
          v.disabled = false
        }
        return v
      })
      this.$emit('update', newOtherRate)
      if (data) {
        this.form.bup_others_explosive[index].code = data.code
        this.form.bup_others_explosive[index].unit = data.unit
        this.form.bup_others_explosive[index].price_unit_idr =
          this.contractor.is_need_exchange
            ? data.rate * this.fuelPrice.rate_usd_to_idr / this.contractor.rate
            : data.rate
        this.form.bup_others_explosive[index].price_unit_usd = (this.form.bup_others_explosive[index].price_unit_idr / this.fuelPrice.rate_usd_to_idr).toFixed(2)
      }
    },
    addRowExplosive() {
      this.otherRate.map(v => {
        this.form.bup_others_explosive.map(i => {
          if (v.id === i.contractor_other_rate_id) {
            v.disabled = true
          }
        })
      })
      this.form.bup_others_explosive.push({
        contractor_other_rate_id: '',
        code: '',
        unit: '',
        qty: '',
        price_unit_usd: '',
        price_unit_idr: '',
        amount: ''
      })
    },
    removeExplosive(index) {
      const id = this.form.bup_others_explosive[index].contractor_other_rate_id
      const newOtherRate = this.otherRate.map(v => {
        if (this.form.bup_others_explosive.length > 1) {
          if (v.id === id) {
            v.disabled = false
          }
        } else {
          v.disabled = false
        }
        return v
      })
      this.$emit('update', newOtherRate)

      this.form.bup_others_explosive = [
        ...this.form.bup_others_explosive.slice(0, index),
        ...this.form.bup_others_explosive.slice(index + 1)
      ]
    },
    async onChangeFile(value) {
      let isTypeAllowed = true
      let isSizeAllowed = true
      if (value.length + this.attachmentExplosive.length > 10) {
        this.$nextTick(() => {
          this.$bvToast.toast('maximum file to upload only 10 files', {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
        return
      }
      const formData = new FormData()
      for (let i = 0; i < value.length; i++) {
        const nameFile = value[i].name.split('.')
        if ((this.attachmentType.includes(nameFile[nameFile.length - 1]))) {
          if (value[i].size < 3072000) {
            formData.append('bup_others_file', value[i])
          } else {
            isSizeAllowed = false
            break
          }
        } else {
          isTypeAllowed = false
          break
        }
      }
      if (!isTypeAllowed) {
        this.$nextTick(() => {
          this.$bvToast.toast('Only PDF, Excel and Doc files are allowed.', {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }

      if (!isSizeAllowed) {
        this.$nextTick(() => {
          this.$bvToast.toast('Max size file 3 mb.', {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }
      if (isTypeAllowed && isSizeAllowed) {
        await this.uploadAttachment(formData, value)
      }
    },
    async uploadAttachment(formData, value) {
      try {
        const data = await api.other
          .uploadAttachment(
            this.$route.params.id ? this.$route.params.id : 0,
            'Explosive',
            formData,
            { onUploadProgress: this.setUploadProgress }
          )
        if (!this.$route.params.id) {
          data[0].map(v => {
            this.form.attachmentExplosiveId.push(v)
          })
          for (const file of Object.entries(value)) {
            this.attachmentExplosive.push({
              file_name: file[1].name,
              size: this.formatBytes(file[1].size),
              url: file[1],
              id: null
            })
          }
          this.form.attachmentExplosiveId.map((v, i) => {
            this.attachmentExplosive[i].id = v
          })
        } else {
          setTimeout(() => this.fetchAttachment(), 1500)
        }
      } catch ({ response }) {
        this.$nextTick(() => {
          this.$bvToast.toast(`${response.status} - ${response.data.error.message}`, {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }
    },
    setUploadProgress({ loaded }) {
      this.upload.progress = loaded
    },
    checkType(fileName) {
      const splitFileName = fileName.split('.')
      return splitFileName[splitFileName.length - 1]
    },
    async removeFile(index, fileId) {
      try {
        this.attachmentExplosive.splice(index, 1)
        this.form.attachmentExplosiveId.splice(index, 1)
        await api.other.deleteAttachment(fileId)
      } catch ({ response }) {
        this.$nextTick(() => {
          this.$bvToast.toast(`${response.status} - ${response.data.error.message}`, {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }
    },
    downloadFile(item) {
      window.open(item.url)
    },
    formatBytes(bytes, decimals = 2) {
      if (!+bytes) return '0 Bytes'

      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB']

      const i = Math.floor(Math.log(bytes) / Math.log(k))

      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    },
    subTotal(item) {
      let x = 0
      item.map(v => {
        if (v.qty) {
          x += v.qty * (parseFloat(v.price_unit_idr) || 0)
        }
      })
      return x
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
